import styled from 'styled-components';

import Row from 'components/Row';

export const ActionsContainer = styled.div`
  display: flex;
  & > *:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacings.abs32}px;
  }
`;

export const TopBarContainer = styled(Row).attrs({
  alignItems: 'center',
  justifyContent: 'space-between',
})`
  height: 100%;
  padding: 0 ${({ theme }) => theme.spacings.abs24}px;
`;
